// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__-hash--base64-5-","Success":"Button__Success__-hash--base64-5-","Danger":"Button__Danger__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 99
// module chunks = 0